import { c as _c } from "react/compiler-runtime";
import React, { type Dispatch, type SetStateAction } from 'react';
import { getClientAvatarUrl } from 'shared/assetsBucket';
import Dots from 'shared/components/Loader/Dots';
import { useAuth } from 'shared/context/AuthContext';
import { useCurrentClient } from 'shared/context/ClientContext';
import { useAvatarUpload } from 'shared/hooks/useAvatarUpload';
import { useMarkNotificationAsRead, useQueryMember } from '../../api';
import { useNotifications } from '../../hooks/useNotifications';
import AvatarContainer from './AvatarContainer';
import NotificationsFlyout from './NotificationsFlyout';
import SwitchWorkspaceFlyout from './SwitchWorkspaceFlyout';
import WorkspaceOverviewFlyout from './WorkspaceOverviewFlyout';
interface FlyoutContentProps {
  isSwitchWorkspace: boolean;
  isUserProfile: boolean;
  isNotifications: boolean;
  setIsUserProfile: Dispatch<SetStateAction<boolean>>;
  isAdminWorkspaceProfile: boolean;
  setIsAdminWorkspaceProfile: Dispatch<SetStateAction<boolean>>;
  handleFlyout: Dispatch<SetStateAction<boolean>>;
}
const FlyoutContent = props => {
  const $ = _c(46);
  const {
    isSwitchWorkspace,
    isNotifications,
    isAdminWorkspaceProfile,
    setIsAdminWorkspaceProfile,
    handleFlyout
  } = props;
  const {
    currentUser
  } = useAuth();
  const {
    currentClient,
    isValidClient
  } = useCurrentClient();
  let t0;
  if ($[0] !== currentClient.id) {
    t0 = {
      clientId: currentClient.id
    };
    $[0] = currentClient.id;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const {
    mutateAsync: uploadAvatar,
    isLoading: isUploading,
    isSuccess: isUploadSuccess
  } = useAvatarUpload(t0);
  const shouldGetWorkspaceMember = !isSwitchWorkspace && isValidClient;
  const {
    data: member,
    isLoading: isMemberLoading
  } = useQueryMember(currentClient.id, currentUser?.id, shouldGetWorkspaceMember);
  const prevIsNotificationsRef = React.useRef(isNotifications);
  const {
    groupedNotifications,
    allNotifications
  } = useNotifications();
  const {
    mutate: markAsRead
  } = useMarkNotificationAsRead();
  let t1;
  if ($[2] !== allNotifications || $[3] !== currentClient.id || $[4] !== isNotifications || $[5] !== markAsRead) {
    t1 = () => {
      if (prevIsNotificationsRef.current && !isNotifications) {
        const notificationsToMarkAsRead = allNotifications.filter(_temp).map(_temp2);
        markAsRead({
          clientId: currentClient.id,
          userNotificationIds: notificationsToMarkAsRead
        });
      }
      prevIsNotificationsRef.current = isNotifications;
    };
    $[2] = allNotifications;
    $[3] = currentClient.id;
    $[4] = isNotifications;
    $[5] = markAsRead;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  let t2;
  if ($[7] !== allNotifications || $[8] !== currentClient.id || $[9] !== groupedNotifications || $[10] !== isNotifications || $[11] !== markAsRead) {
    t2 = [isNotifications, groupedNotifications, currentClient.id, markAsRead, allNotifications];
    $[7] = allNotifications;
    $[8] = currentClient.id;
    $[9] = groupedNotifications;
    $[10] = isNotifications;
    $[11] = markAsRead;
    $[12] = t2;
  } else {
    t2 = $[12];
  }
  React.useEffect(t1, t2);
  if (isSwitchWorkspace) {
    let t3;
    if ($[13] !== handleFlyout) {
      t3 = <SwitchWorkspaceFlyout handleFlyout={handleFlyout} />;
      $[13] = handleFlyout;
      $[14] = t3;
    } else {
      t3 = $[14];
    }
    return t3;
  }
  if (isNotifications) {
    let t3;
    if ($[15] !== handleFlyout || $[16] !== isNotifications) {
      t3 = <NotificationsFlyout handleFlyout={handleFlyout} open={isNotifications} />;
      $[15] = handleFlyout;
      $[16] = isNotifications;
      $[17] = t3;
    } else {
      t3 = $[17];
    }
    return t3;
  }
  const t3 = currentClient.name;
  const t4 = currentClient.id;
  const t5 = currentClient.url ?? "";
  let t6;
  if ($[18] !== currentClient.id) {
    t6 = getClientAvatarUrl(currentClient.id);
    $[18] = currentClient.id;
    $[19] = t6;
  } else {
    t6 = $[19];
  }
  const t7 = member?.role ?? "viewer";
  let t8;
  if ($[20] !== isUploadSuccess || $[21] !== isUploading || $[22] !== uploadAvatar) {
    t8 = {
      uploadAvatar,
      isUploading,
      isUploadSuccess
    };
    $[20] = isUploadSuccess;
    $[21] = isUploading;
    $[22] = uploadAvatar;
    $[23] = t8;
  } else {
    t8 = $[23];
  }
  let t9;
  if ($[24] !== currentClient.id || $[25] !== currentClient.name || $[26] !== t5 || $[27] !== t6 || $[28] !== t7 || $[29] !== t8) {
    t9 = <AvatarContainer name={t3} id={t4} url={t5} avatarUrl={t6} role={t7} uploadAvatarProps={t8} />;
    $[24] = currentClient.id;
    $[25] = currentClient.name;
    $[26] = t5;
    $[27] = t6;
    $[28] = t7;
    $[29] = t8;
    $[30] = t9;
  } else {
    t9 = $[30];
  }
  let t10;
  if ($[31] !== isMemberLoading) {
    t10 = isMemberLoading && <Dots />;
    $[31] = isMemberLoading;
    $[32] = t10;
  } else {
    t10 = $[32];
  }
  let t11;
  if ($[33] !== isUploadSuccess || $[34] !== isUploading || $[35] !== uploadAvatar) {
    t11 = {
      uploadAvatar,
      isUploading,
      isUploadSuccess
    };
    $[33] = isUploadSuccess;
    $[34] = isUploading;
    $[35] = uploadAvatar;
    $[36] = t11;
  } else {
    t11 = $[36];
  }
  let t12;
  if ($[37] !== handleFlyout || $[38] !== isAdminWorkspaceProfile || $[39] !== setIsAdminWorkspaceProfile || $[40] !== t11) {
    t12 = <WorkspaceOverviewFlyout handleFlyout={handleFlyout} isAdminWorkspaceProfile={isAdminWorkspaceProfile} setIsAdminWorkspaceProfile={setIsAdminWorkspaceProfile} uploadAvatarProps={t11} />;
    $[37] = handleFlyout;
    $[38] = isAdminWorkspaceProfile;
    $[39] = setIsAdminWorkspaceProfile;
    $[40] = t11;
    $[41] = t12;
  } else {
    t12 = $[41];
  }
  let t13;
  if ($[42] !== t10 || $[43] !== t12 || $[44] !== t9) {
    t13 = <>{t9}{t10}{t12}</>;
    $[42] = t10;
    $[43] = t12;
    $[44] = t9;
    $[45] = t13;
  } else {
    t13 = $[45];
  }
  return t13;
};
export default FlyoutContent;
function _temp(notification) {
  return !notification.isRead;
}
function _temp2(notification_0) {
  return notification_0.id;
}